import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { UserService } from 'src/app/services/user.service';
import { CyclistService } from 'src/app/services/cyclist.service';
import { HelpersService } from 'src/app/services/helpers.service';

@Component({
  selector: 'app-workshop-jobcard-customer-exists',
  templateUrl: './workshop-jobcard-customer-exists.component.html',
  styleUrls: ['./workshop-jobcard-customer-exists.component.scss']
})
export class WorkshopJobcardCustomerExistsComponent {

  @Input() jobcard: any;
  @Input() existingCustomer: any;
  @Input() newCustomer: any;
  @Output() customerSelected = new EventEmitter<any>();

  public customer: any = {};
  public updating: boolean = false;

  constructor(
    public activeModal: NgbActiveModal,
    private translate: TranslateService,
    private userService: UserService,
    private cyclistService: CyclistService,
    private helpersService: HelpersService
  ) { }


  selectExistingCustomer(){
    if (this.existingCustomer && this.existingCustomer.ID) {
      this.jobcard.customer = { ...this.existingCustomer };
      this.activeModal.close({ ...this.jobcard });
    }
  }

  editExistingCustomer(){
      this.activeModal.close({ action: 'edit', customer: this.existingCustomer });
  }

  cancel(){
    this.activeModal.dismiss('cancel');
  }

}
